<template>
<div>
  <RigaInterventoStorico v-for="(intervento, index) in this.listaInterventiShow" 
    :key="index"
    :index="index"
    :intervento="intervento">
  </RigaInterventoStorico>
</div>
</template>

<script>

import RigaInterventoStorico from "@/components/RigaInterventoStorico.vue";


export default {
  name: "GrigliaInterventiStorico",  
  components: {
    RigaInterventoStorico
  },
  data(){
    return {
      listaInterventiShow: []  
    }
  },
  watch:{
    listaInterventi: function(newValue){     
      this.listaInterventiShow = newValue;     
    }
  },
  props: {
    listaInterventi: Array
  },  
  mounted: function(){
      this.$store.dispatch({
        type: "getEsitiOperazioni",
        token: this.$store.getters.getUtente.Token,
      });
  }
}
</script>